import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/LmPersonaApi/" );

/* eslint-disable arrow-body-style */
/* eslint-disable object-shorthand */
/* eslint-disable quote-props */

/*
 * GET
 */

/**
 * Retrieves a list of instances
 */
export const listInstances = () => {
  return instance.get( "ListInstances" );
};

/**
 * Retrieves a list of instances related to the user
 */
export const listUserInstances = () => {
  return instance.get( "listUserInstances" );
};

/*
 * Loads a specific instance
 */
export const loadInstance = ( id ) => {
  return instance.get( `LoadInstance?id=${id}` );
};

/*
 * Retrieves an Persona instances questions and answers
 */
export const listQuestions = ( instanceId = null ) => {
  return instance.get( `ListQuestions?instanceId=${instanceId}` );
};

/*
 * Retrieves the final report for an instance
 */
export const getFinalReportData = ( instanceId ) => {
  return instance.get( `GetFinalReportData?instanceId=${instanceId}` );
};

/*
 * Retrieves the suggested results
 */
export const getResultSuggestedTopics = ( instanceId ) => {
  return instance.get( `GetResultSuggestedTopics?instanceId=${instanceId}` );
};

/*
 * POST
 */

/*
 * Saves answers for an instance
 */
export const saveAnswers = ( { instanceId, answers, markAsComplete } ) => {
  return instance.post( "SaveAnswers", { instanceId, answers, markAsComplete } );
};

/*
 * Saves a new or existing Persona instance to the user's account
 */
export const saveInstance = ( {
  instanceId, instanceName, pathwayItemId,
} ) => {
  const payload = {
    instanceId,
    instanceName,
    pathwayItemId,
  };

  return instance.post( "SaveInstance", payload );
};
